<template>
  <div class="home">
    <header class="hero" role="banner">
      <div class="hero-inner">
        <img class="avatar" src="/icon.png" alt="Mio" />
        <h1 class="title">Mio · 弥央</h1>
        <p class="subtitle">异度之刃3 | 日常碎片 | 笛声与战技笔记</p>
      </div>
    </header>

    <main class="content" role="main">
      <div class="container">
        <!-- 主博客推荐 -->
        <section class="main-blog-promo">
          <div class="promo-content">
            <div class="promo-text">
              <h2>🚀 探索我的主博客</h2>
              <p>在 <strong>www.eunie.online</strong> 发现更多精彩内容</p>
              <p class="promo-description">深度技术文章、游戏攻略、生活感悟，以及更完整的创作体验</p>
            </div>
            <div class="promo-action">
              <a href="https://www.eunie.online" target="_blank" rel="noopener" class="cta-button">
                访问主博客 →
              </a>
            </div>
          </div>
        </section>

        <!-- 博客文章列表 -->
        <BlogList :showLoadMoreButton="true" />
      </div>
    </main>
  </div>
  
</template>

<script>
import BlogList from '@/components/BlogList.vue'
import { SEOUtils } from '@/utils/seo.js'

export default {
  name: 'Home',
  components: {
    BlogList
  },
  mounted() {
    // 为首页添加特定的结构化数据
    this.addHomeStructuredData()
  },
  methods: {
    addHomeStructuredData() {
      const websiteData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "弥央大学",
        "alternateName": "Mio University",
        "description": "弥央大学提供免费edu邮箱申请教程，教育邮箱白嫖攻略，免费入学指南。教育资源分享平台。",
        "url": "https://mio.edu.kg",
        "author": {
          "@type": "Person",
          "name": "弥央",
          "description": "教育资源分享者"
        },
        "publisher": {
          "@type": "Organization",
          "name": "弥央大学",
          "logo": {
            "@type": "ImageObject",
            "url": "https://mio.edu.kg/icon.png"
          }
        },
        "inLanguage": "zh-CN",
        "copyrightYear": "2025",
        "genre": ["教育", "教程", "免费资源", "edu邮箱", "技术", "个人博客"],
        "keywords": "弥央大学,edu邮箱,教育邮箱,白嫖,教程,免费入学,异度之刃3,个人博客,教育资源,免费资源",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://mio.edu.kg/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }
      
      SEOUtils.addStructuredData(websiteData)
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
}

.hero {
  /* 统一缩放：填满容器、不留空白 */
  background: url('/bg.jpg') center/cover no-repeat;
  min-height: 52vh;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 4rem 1rem;
  position: relative;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.35);
}

.hero-inner {
  position: relative;
  z-index: 1;
  color: #fff;
}

.avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.9);
  margin-bottom: 1rem;
}

.title { font-size: 2rem; margin: 0 0 .4rem 0; }
.subtitle { opacity: .95; margin: 0; }

.content {
  background: #fff;
  flex: 1; // 占据剩余空间，避免底部出现大块留白
  /* 为避免首页初始就出现 Footer，增加正文的最小高度。
    头图 52vh + 正文 52vh ≈ 104vh，确保需要滚动才见到底部。*/
  min-height: 52vh;
}
.container { max-width: 880px; margin: 0 auto; padding: 2rem 1rem; }

.main-blog-promo {
  background: #fff;
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  
  .promo-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    
    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
      gap: 1.5rem;
    }
  }
  
  .promo-text {
    flex: 1;
    
    h2 {
      color: #333;
      font-size: 1.5rem;
      margin: 0 0 0.5rem 0;
    }
    
    p {
      color: #666;
      margin: 0.5rem 0;
      
      &.promo-description {
        font-size: 0.95rem;
        color: #888;
      }
      
      strong {
        color: #e64fa7;
        font-weight: 600;
      }
    }
  }
  
  .promo-action {
    .cta-button {
      background: #e64fa7;
      border: none;
      color: white;
      padding: 1rem 2rem;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.3s ease;
      display: inline-block;
      
      &:hover {
        background: #d63384;
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(230, 79, 167, 0.3);
      }
    }
  }
}

@media (max-width: 768px){
  .title { font-size: 1.6rem; }
  .subtitle { font-size: .95rem; }
}
</style>
